import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import App from "./App";
import "@/styles/globals.css";
import { initGtagDeferred } from "@/lib/gtag";

try {
  if (typeof localStorage !== "undefined" && localStorage.getItem("darkMode") === "true") {
    document.documentElement.classList.add("dark-mode");
    const tc = document.querySelector('meta[name="theme-color"]');
    if (tc) tc.setAttribute("content", "#1a1a1a");
  }
} catch {
  /* ignore */
}

initGtagDeferred();

if (import.meta.env.VITE_SENTRY_DSN) {
  const initSentry = () => {
    import("@sentry/react").then((Sentry) => {
      Sentry.init({
        dsn: import.meta.env.VITE_SENTRY_DSN,
        integrations: [Sentry.browserTracingIntegration()],
        tracesSampleRate: 0.1,
      });
    });
  };
  if (typeof requestIdleCallback === "function") {
    requestIdleCallback(initSentry, { timeout: 6000 });
  } else {
    setTimeout(initSentry, 2000);
  }
}

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);
